import MyModal from "./MyModal";
import Spinner from "./Spinner";
import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import { getMemberProfile, unsubscribeMember } from './../api/index';
import './HandleAccount.css';

const HandleAcount = (props) => {

    const [showModal, setShowModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [confirm, setConfirm] = useState(false);
    const [error, setError] = useState(false);

    const { data: profile } = useQuery(['profile'], async () => await getMemberProfile());

    const handleClose = () => {
        setShowModal(false);

        if (redirect) {
            document.location.href = '/fr/actualites';
        }
    }

    const handleConfirm = async () => {
        setIsLoading(true);
        setConfirm(false);
        setRedirect(true);

        try {
            const res = await unsubscribeMember();
            setIsLoading(false);
            setShowModal(true);
            if (res.status !== 200) {
                setError(true);
            }
        } catch (error) {
            setIsLoading(false);
            setShowModal(true);
            setError(true);
        }
    }

    const getModalData = () => {
        return {
            title: "Désinscription espace membre",
            body: error ? "Une erreur est survenue. Veuillez réessayer ultérieurement." : confirm ? "Etes-vous sûr de vouloir vous désinscrire ?" : "Votre demande de désinscription a bien été prise en compte."
        }
    }

    const handleOnClickForgottenPassword = () => {
        setIsLoading(true);
        document.location.href = '/fr/mot-de-passe-oublie';
    }

    const handleOnClickUnsubscribe = () => {
        setShowModal(true);
        setConfirm(true);
    }

    const renderPage = (
        <div class="row">
            <div class="col-md-12">
                <div class="tuile-title">Mon statut</div>
                <div class="flex space-between margin-10">
                    <p class="font-l font-300">Vous êtes actuellement&nbsp;
                        {props.role === 'premium' ? <strong class="color-a">Membre Premium</strong> : <strong class="color-f">Membre Basique</strong>}
                        &nbsp;Bourse Direct
                    </p>
                    <button class="btn btn-secondary font-600 padding-7-30" onClick={handleOnClickUnsubscribe}> Me désinscrire</button>
                </div>
            </div>
            <div class="col-md-12">
                <div class="tuile-title">Connexion</div>
                <div class="row">
                    <div class="col-md-6 col-xs-12">
                        <div class="panel panel-h120 panel-center panel-grey-light">
                            <p class="font-l font-300">Votre E-mail : <b>{profile ? profile.email : ""}</b></p>
                        </div>
                    </div>
                    <div class="col-md-6 col-xs-12">
                        <div class="panel panel-h120 panel-center panel-grey-light align-flex-column">
                            <p class="font-l font-300">Votre mot de passe : <b>******</b></p>
                            <button onClick={handleOnClickForgottenPassword} class="btn btn-primary font-600 padding-7-30">Modifier mon mot de passe</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )

    return (
        <>
            {isLoading ? <Spinner />: renderPage}
            <MyModal
                show={showModal}
                handleClose={handleClose}
                bodyText={getModalData().body}
                titleText={getModalData().title}
                twoButtons={confirm}
                handleConfirm={handleConfirm}
            />
        </>
    )
}

export default HandleAcount;
